import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-appointment-confirm-send-confirmation-dialog',
  templateUrl: './appointment-confirm-send-confirmation-dialog.component.html',
  styleUrls: ['./appointment-confirm-send-confirmation-dialog.component.scss'],
})
export class AppointmentConfirmSendConfirmationDialogComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      messagePreferenceId: number;
      emailAddress: string;
      phoneNumber: string;
    }
  ) {}

  ngOnInit(): void {}
}
